<template>
  <div class="situation-map" :class="isAutoExportPng ? 'autoExportPng' : ''">
    <div class="country-info">
      <AbPlayerImg
        v-if="playerInfo.playerId"
        :playerImg="playerInfo.profilePicture"
        :playerNum="playerInfo.shirtNumber * 1"
        :playerName="playerInfo.playerName"
        :countryImg="objectInfo.teamLogo"
        :countryName="objectInfo.teamName"
        :age="playerInfo.age"
        :clubName="playerInfo.clubName"
        :height="playerInfo.height"
        :width="'100%'"
      />
      <template v-else>
        <div class="country-logo">
          <img :src="objectInfo.teamLogo" alt="" />
        </div>
        <div class="country-name">
          {{ objectInfo.teamName }}
        </div>
      </template>
    </div>
    <div class="ball-situation-box">
      <div class="ball-situation-content">
        <div class="situation-items">
          <div
            class="situation-item"
            :class="{ left: isAway }"
            v-for="pct in pctList"
            :key="pct.label"
          >
            <div class="situation-item-bar" :style="{ width: pct.width }"></div>
            <span class="situation-item-label">{{ pct.label }}</span>
            <span class="situation-item-value">{{ pct.value }}%</span>
          </div>
        </div>
      </div>
      <div class="situation-item-info">
        <span v-for="item in bottomList" :key="item.label">
          {{ item.label }} {{ item.value }}%
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import AbPlayerImg from '@components/compreSportsMeet/html/components/PlayerImg.vue'

export default {
  name: 'situation-map',
  components: { AbPlayerImg },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    isBorder: {
      type: Boolean,
      default: false,
    },
    isAutoExportPng: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    objectInfo() {
      return this.datas?.objectInfo?.[0] || {}
    },
    playerInfo() {
      return this.objectInfo?.playerInfos?.[0] || {}
    },
    isAway() {
      const teamType = this.objectInfo?.teamType
      return teamType === 'away'
    },
    pctData() {
      return this.datas?.data?.dataList?.[0] || {}
    },
    pctList() {
      const { leftPct, centePct, rightPct } = this.pctData
      if (!leftPct && !centePct && !rightPct) return []
      const max = Math.max(leftPct, centePct, rightPct)
      const num = Math.min(80 - max, 30)
      const list = [
        { label: '左', value: leftPct, width: `${leftPct + num}%` },
        { label: '中', value: centePct, width: `${centePct + num}%` },
        { label: '右', value: rightPct, width: `${rightPct + num}%` },
      ]
      return this.isAway ? list.reverse() : list
    },
    bottomList() {
      const { defensePct, attackPct, midfieldPct } = this.pctData
      if (!defensePct && !attackPct && !midfieldPct) return []
      const list = [
        { label: '防守', value: defensePct },
        { label: '中场', value: midfieldPct },
        { label: '进攻', value: attackPct },
      ]
      return this.isAway ? list.reverse() : list
    },
  },
}
</script>

<style lang="scss" scoped>
.situation-map {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2vw;
  padding: 2% 3%;
  &.autoExportPng {
    width: 100%;
    .ball-situation-box .ball-situation-content {
      border: 0;
      background-color: transparent;
      border-radius: 0;
    }
  }
  .country-info {
    flex: 1;
    .country-logo {
      width: 100%;
      position: relative;
      width: 50%;
      margin: 0 auto;
      margin-bottom: 1.388vw;
      &::before {
        content: ' ';
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        width: 100%;
        height: 100%;
        border: 1px solid var(--mixtmt_greyColor5);
      }
      img {
        width: 100%;
      }
    }
    .country-name {
      text-align: center;
      color: var(--mixtmt_greyColor_main);
    }
  }
  .ball-situation-box {
    width: 70%;
    height: 0;
    padding-bottom: calc(67.11% * 0.7);
    position: relative;
    .ball-situation-content {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: url(~@/assets/images/ball_situation_bg.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center;
      border: 0.416vw solid var(--mixtmt_echarts_footBallPlaygroundColor);
      border-radius: 0.694vw;
      background-color: var(--mixtmt_echarts_footBallPlaygroundColor);
    }
    .situation-items {
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.2);
      .situation-item {
        width: 100%;
        height: 33.3333%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 0 0.4vw;
        font-size: 1vw;
        line-height: 1;
        color: #8efed5;
        font-weight: bold;
        gap: 0.3vw;
        &.left {
          justify-content: flex-end;
          .situation-item-value {
            order: 1;
          }
          .situation-item-label {
            order: 2;
          }
          .situation-item-bar {
            order: 3;
            margin-right: 0;
            margin-left: 1vw;
            background: linear-gradient(
              to left,
              rgba(142, 254, 213, 0.1) 0%,
              #8efed5 100%
            );
            &::after {
              left: -0.9vw;
              border-top: 0.8vw solid transparent;
              border-bottom: 0.8vw solid transparent;
              border-right: 1vw solid #8efed5;
              border-left: none;
            }
          }
        }
        .situation-item-bar {
          width: 20%;
          height: 0.72vw;
          margin-right: 1vw;
          background: linear-gradient(
            to right,
            rgba(142, 254, 213, 0.1) 0%,
            #8efed5 100%
          );
          position: relative;
          &::after {
            content: '';
            position: absolute;
            top: 50%;
            right: -0.9vw;
            transform: translateY(-50%);
            width: 0;
            height: 0;
            border-top: 0.8vw solid transparent;
            border-bottom: 0.8vw solid transparent;
            border-left: 1vw solid #8efed5;
          }
        }
      }
    }
    .situation-item-info {
      width: 100%;
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 0.4vw;
      gap: 2.4vw;
      font-size: 0.9vw;
      color: var(--mixtmt_greyColor3);
      font-weight: bold;
    }
  }
}
</style>
